// Terms of digital signing for Swan Schools.
// Bump TERMS_VERSION whenever the wording materially changes; users will
// be re-prompted to accept on next signing.
//
// The Cloud Function (functions/api/signing.js) hard-codes the same version —
// keep them in sync.

export const TERMS_VERSION = 1;

export const TERMS_TITLE = "Setting up your signature";

export const TERMS_INTRO =
  "From now on, when you're asked to sign something on Swan, you're signing it for real. " +
  "These signatures carry the same legal weight as signing a piece of paper.";

export const TERMS_POINTS = [
  {
    heading: "What counts as your signature",
    body:
      "You'll choose one method on the next step — tapping Sign, typing your full legal name, " +
      "using your device's fingerprint or face recognition, or entering a 4-digit PIN. " +
      "Whichever you pick is your signature. Using it means yes, with the same weight " +
      "as signing in pen.",
  },
  {
    heading: "What we record",
    body:
      "When you sign, we record who you are, the moment you signed, the document you " +
      "signed (frozen at that exact moment), and which method you used. This record " +
      "cannot be changed afterwards.",
  },
  {
    heading: "You're in control",
    body:
      "You can only sign things you've been asked to sign. You'll see the document " +
      "before you sign. You'll never be charged a fee or sign a financial agreement " +
      "through this. If you're unsure about something, don't sign it.",
  },
  {
    heading: "If you change your mind",
    body:
      "A signature, once made, stands. But you can change your signing method later " +
      "in your account settings if your phone changes or you forget your PIN.",
  },
];

export const TERMS_AGREEMENT_LABEL =
  "I understand. My signature on Swan is legally binding.";
